import { Outlet } from "react-router-dom";
import { ContentProvider, useContentContext } from "./ContentContext";
import { Layout, theme } from "antd";

const { Header, Content, Footer } = Layout;

export default function ContentLayout() {
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

    return (
        <ContentProvider>
            <Layout style={{ borderRadius: borderRadiusLG, background: colorBgContainer }} className="mx-auto max-w-none bg-surface min-h-[calc(100vh-64px)]">
                {/* Сюда будут поочередно рендериться WithTabsLayout или WithDetailLayout */}
                <Outlet />
            </Layout>
        </ContentProvider>
    );
}